module.exports = __webpack_public_path__ + "img/triangle.a58fe17f.svg";